import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { KYMW1319Model } from './kymw1319.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { KYMW1319InputVO } from './vo/kymw1319-inputVO.model';
import { GetFeatureThemaListForUpdateService } from './api-services/get-feature-thema-list-for-update.service';
import { GetSelectedPlanGoodsFeatureListService } from './api-services/get-selected-plan-goods-feature-list.service';
import { UpdatePlanGoodsFeatureService } from './api-services/update-plan-goods-feature.service';
import { GetBundleCatalogInfoForFeatureResponce, GetBundleCatalogInfoForFeatureService } from './api-services/get-bundle-catalog-info-for-feature.service';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { PlanGoodsLockService } from 'src/app/commons/kymw00/api-services/plan-goods-lock.service';

/**
 * 特集付替設定画面を管理するクラス
 *
 * @export KYMW1319Component
 * @class KYMW1319Component
 */
@Component({
  selector: 'app-kymw1319',
  templateUrl: 'kymw1319.component.html',
  styleUrls: ['kymw1319.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1319Component extends PlessViewHelperSub implements OnInit {

  setKYMW1319Parameter: Function;
  kymw1319Model = new KYMW1319Model();
  kymw1319InputVO = new KYMW1319InputVO();

  /** 画面編集モード */
  editMode: boolean = <boolean>true;
  /** 変更フラグ */
  isEdited: boolean = <boolean>false;

  @ViewChild('dtg_selectedFeatureList', { static: true }) dtg_selectedFeatureList: FlexGrid;

  /**
   * Creates an instance of KYMW1319Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1319Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    public getFeatureThemaListForUpdateService: GetFeatureThemaListForUpdateService,
    public getSelectedPlanGoodsFeatureListService: GetSelectedPlanGoodsFeatureListService,
    public updatePlanGoodsFeatureService: UpdatePlanGoodsFeatureService,
    public getBundleCatalogInfoForFeatureService: GetBundleCatalogInfoForFeatureService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);
  }

  /**
  * 前画面からのパラメータ設定
  *
  * @param {*}
  * @memberof KYMW1319Component
  */
  public setInterfaceParam(param: KYMW1319InputVO) {
    this.kymw1319InputVO = param;
    this.editMode = param.editLockFlag === this.kymw1319Model.EDIT_MODE;
  }

  /**
   * 初期処理
   *
   * @return {*}  
   * @memberof KYMW1319Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1319';
    this.kymw1319Model.kymw1319Component = this;
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // 束ね企画対象の場合、束ね企画情報取得
    if (this.kymw1319InputVO.bundleCatalogFlag === this.kymw1319Model.BUNDLE_CATALOG_TARGET) {
      this.getBundleCatalogInfoForFeatureService.execute(this.kymw1319InputVO, (data) => {
        this.initSetting(this.kymw1319InputVO, data);
      });
    } else {
      this.initSetting(this.kymw1319InputVO);
    }

    this.dtg_selectedFeatureList.itemsSourceChanged.addHandler(() => {
      this.dtg_selectedFeatureList.select(-1, -1);

      // 1:企画確定済み の受注コードの列はグレーアウトして表示する。
      this.dtg_selectedFeatureList.rows.forEach((row) => {
        if (row.dataItem.CatalogFixedFlag === this.kymw1319Model.CATALOG_FIXED_FLAG) {
          row.cssClass = "backgroud-color-gray";
        }
      })
    });
  }

  /**
   * 初期表示
   * 
   * @param inputVO KYMW1300から引き継いだ情報
   * @param serverData 束ね企画対象の場合に取得した、束ね企画情報
   * @memberof KYMW1319Component
   */
  public async initSetting(inputVO: KYMW1319InputVO, serverData: GetBundleCatalogInfoForFeatureResponce = null) {

    // 画面表示
    this.kymw1319Model.formatDisplayValue(inputVO, serverData);

    await this.initGrid();

    // 工程履歴Noが7以上の場合、画面を非活性にする
    if (PlessViewUtilsSub.stringToNumber(inputVO.progressWorkNum) >= 7 ||
      (PlessViewUtilsSub.isEmpty(inputVO.progressWorkNum) && PlessViewUtilsSub.stringToNumber(serverData?.ProgressWorkNum) >= 7)
    ) {
      this.editMode = false;
      return
    }

    // 編集ロックが解除されている場合
    if (this.editMode) {
      // 企画商品ロック
      for (let i = 0; i < this.kymw1319Model.selectedFeatureList.length; i++) {
        this.LockUtilForPlanGoods('REGIST',
          this.kymw1319Model.selectedFeatureList[i].OrderCode,
          inputVO.mediumType, inputVO.pcode,
          null, null,
          () => {
            this.dialogService.openAlertGetMessage('I0523');
            this.editMode = false;
            this.lock_Release(this.kymw1319Model.selectedFeatureList, i + 1);   // 成功した件数分とするため+1
          }, inputVO, false
        );
      }
    }

    // 特集情報取得
    this.getFeatureThemaListForUpdateService.execute(inputVO, this.kymw1319Model, (data) => {
      this.kymw1319Model.featureInfoList = data.FeatureInfoList;
    });
  }

  /**
   * ロック解除
   * 
   * @memberof KYMW1319Component
   */
  public lock_Release(list: Array<any>, length: number = list.length) {
    for (let i = 0; i < length; i++) {
      this.LockUtilForPlanGoods(
        'RELEASE',
        list[i].OrderCode, this.kymw1319InputVO.mediumType, this.kymw1319InputVO.pcode,
        null, null, null, null, false
      );
    }
  }

  /**
   * 設定済み特集一覧取得
   * 
   * @memberof KYMW1319Component
   */
  async initGrid(): Promise<any> {
    await new Promise<void>((resolve) => {
      this.getSelectedPlanGoodsFeatureListService.execute(this.kymw1319Model, this.kymw1319InputVO, (data) => {
        this.kymw1319Model.formatListValue(data.SelectedFeatureList);
        resolve();
      });
    })
  }

  /**
   * 変更フラグ
   * 
   * @memberof KYMW1319Component
   */
  public eventFeatureCode_CHANGEHandler() {
    this.isEdited = true;
  }

  /**
   * 設定ボタン押下時
   *
   * @memberof KYMW1319Component
   */
  public eventSet_CLICKHandler() {
    this.updatePlanGoodsFeatureService.execute(this.kymw1319Model, this.kymw1319InputVO, () => {
      // 一覧再取得
      this.initGrid();
      this.dialogService.openAlertGetMessage('I0513');
      this.isEdited = false;
    });
  }

  /**
   * 閉じるボタン押下
   *
   * @memberof KYMW1319Component
   */
  public onClickClose(): void {
    if (this.isEdited) {
      this.dialogService.openAlertGetMessage('Q0107', ['企画商品特集情報'], (e) => {
        if (e === PlessAlert.Yes) {
          this.lock_Release(this.kymw1319Model.selectedFeatureList);
          super.onClickClose();
        }
      });
    } else {
      if (this.editMode) {
        this.lock_Release(this.kymw1319Model.selectedFeatureList);
      }
      super.onClickClose();
    }
  }
}
